class AssetSizeRule {
  readonly #asset;
  constructor(asset) {
    this.#asset = asset;
  }

  get asset() {
    return this.#asset;
  }

  containsOfferSize(offerSize) {
    return (
      this.#asset?.imageSizes?.some(
        (size) => size.teeShirtSize === offerSize
      ) || false
    );
  }
}

export default AssetSizeRule;
